// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"681c48d5","453":"ba99e223","732":"0e01dc04","762":"a55edd8d","977":"346c79b8"}[chunkId] + ".chunk.js";
};